module.exports = __webpack_public_path__ + "static/media/sf-logo-simple.d0d10159.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sf-logo-simple.png
// module id = 226
// module chunks = 0